import { v4 as uuid } from "uuid";

export type UserLineItem = {
  id: string;
  email: string;
};

export const createDefaultUser = (email: string, id?: string): UserLineItem => {
  return {
    id: id ? id : uuid(),
    email: email,
  };
};
